export default "__VITE_ASSET__CDBBTtGN__"